(function () {
  const dataEl = document.getElementById('variant-gallery-data');
  if (!dataEl) return;

  let galleryData = {};
  try {
    galleryData = JSON.parse(dataEl.textContent);
  } catch (e) { return; }

  // Ocultar flechas de Clarity
  const style = document.createElement('style');
  style.textContent = 'media-gallery slideshow-arrows { display: none !important; }';
  document.head.appendChild(style);

  let currentIndex = 0;
  let currentImages = [];

  const strip = document.createElement('div');
  strip.id = 'metafield-thumbnail-strip';
  strip.style.cssText = `
    display: none;
    gap: 8px;
    flex-wrap: wrap;
    padding: 8px 0;
    margin-top: 8px;
    width: 100%;
    justify-content: center;
  `;

  const btnPrev = document.createElement('button');
  btnPrev.innerHTML = '&#8249;';
  btnPrev.style.cssText = `
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    background: rgba(255,255,255,0.8);
    border: none;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    font-size: 32px;
    cursor: pointer;
    line-height: 1;
    display: none;
  `;

  const btnNext = document.createElement('button');
  btnNext.innerHTML = '&#8250;';
  btnNext.style.cssText = `
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    background: rgba(255,255,255,0.8);
    border: none;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    font-size: 32px;
    cursor: pointer;
    line-height: 1;
    display: none;
  `;

  btnPrev.addEventListener('click', () => {
    if (currentImages.length === 0) return;
    currentIndex = (currentIndex - 1 + currentImages.length) % currentImages.length;
    swapMainImage('https:' + currentImages[currentIndex]);
    setActiveThumb(currentIndex);
  });

  btnNext.addEventListener('click', () => {
    if (currentImages.length === 0) return;
    currentIndex = (currentIndex + 1) % currentImages.length;
    swapMainImage('https:' + currentImages[currentIndex]);
    setActiveThumb(currentIndex);
  });

  function getVariantId() {
    const checked = document.querySelector('variant-picker input[type="radio"]:checked');
    return checked?.getAttribute('data-variant-id');
  }

  function setActiveThumb(index) {
    strip.querySelectorAll('img').forEach((img, i) => {
      img.style.outline = i === index ? '2px solid currentColor' : 'none';
      img.style.opacity = i === index ? '1' : '0.6';
    });
  }

  function swapMainImage(url) {
    const mainImg = document.querySelector('media-gallery img');
    if (!mainImg) return;
    mainImg.removeAttribute('srcset');
    mainImg.src = url;
  }

  function buildStrip(variantId) {
    strip.innerHTML = '';
    currentImages = galleryData[String(variantId)] || [];
    currentIndex = 0;

    if (currentImages.length === 0) {
      strip.style.display = 'none';
      btnPrev.style.display = 'none';
      btnNext.style.display = 'none';
      return;
    }

    strip.style.display = 'flex';
    btnPrev.style.display = 'block';
    btnNext.style.display = 'block';

    currentImages.forEach((imgUrl, i) => {
      const url = 'https:' + imgUrl;
      const thumb = document.createElement('img');
      thumb.src = url;
      thumb.style.cssText = `
        width: 64px;
        height: 64px;
        object-fit: cover;
        cursor: pointer;
        border-radius: 4px;
        opacity: 0.6;
        transition: opacity 0.2s;
      `;

      thumb.addEventListener('click', () => {
        currentIndex = i;
        swapMainImage(url);
        setActiveThumb(i);
      });

      strip.appendChild(thumb);
    });

    setTimeout(() => {
      swapMainImage('https:' + currentImages[0]);
      setActiveThumb(0);
    }, 150);
  }

  function insertStrip() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const slideshow = gallery.querySelector('slideshow-component');
    if (slideshow) {
      slideshow.style.position = 'relative';
      if (!slideshow.querySelector('#metafield-btn-prev')) {
        btnPrev.id = 'metafield-btn-prev';
        btnNext.id = 'metafield-btn-next';
        slideshow.appendChild(btnPrev);
        slideshow.appendChild(btnNext);
      }
    }

    if (!document.getElementById('metafield-thumbnail-strip')) {
      gallery.appendChild(strip);
    }
  }

  // Reinsertar si Clarity regenera el DOM
  const observer = new MutationObserver(() => {
    if (!document.getElementById('metafield-thumbnail-strip') ||
        !document.getElementById('metafield-btn-prev')) {
      insertStrip();
      const variantId = getVariantId();
      if (variantId) buildStrip(variantId);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  insertStrip();
  setTimeout(() => buildStrip(getVariantId()), 500);

  const variantPicker = document.querySelector('variant-picker');
  if (!variantPicker) return;

  variantPicker.addEventListener('variant:update', () => {
    const variantId = getVariantId();
    if (variantId) buildStrip(variantId);
  });


   // Cambio de imagen al seleccionar leyenda
  const leyendaImagenMap = {
    'Crema': 0,
    'Jabón': 1,
    'Shampoo': 2,
    'Gel': 3,
    'Acondicionador': 4
  };

  function cambiarImagenPrincipal(leyenda) {
    const indice = leyendaImagenMap[leyenda];
    if (indice === undefined || currentImages.length === 0) return;
    if (indice >= currentImages.length) return;
    currentIndex = indice;
    swapMainImage('https:' + currentImages[indice]);
    setActiveThumb(indice);
  }

  document.addEventListener('leyenda:selected', function(e) {
    cambiarImagenPrincipal(e.detail.valor);
  });
  
})();